<script setup lang="ts">
const { menuItems } = usePanelDesktopMenu();
const { form } = usePersonalDataForm();

const emit = defineEmits(["updateMenuState"]);
const toggleMenu = () => {
  emit("updateMenuState");
};
const { logout } = useLogout();
function logUserOut() {
  logout();
}
</script>

<template>
  <aside class="min-w-[307px]">
    <div
      class="fixed h-full max-h-[calc(100vh)] w-full overflow-y-auto bg-gray-100 px-4 py-4
        [scrollbar-width:none] xl:w-[307px] xl:bg-primary"
    >
      <!-- <div class="h-full w-[307px] bg-primary px-4 py-6"> -->
      <!-- width="191" -->
      <div class="flex items-center justify-between">
        <img src="/app-logo.png" class="hidden xl:block" />
        <p class="ml-1 text-lg font-medium text-gray-900 xl:hidden">Menu</p>
        <button
          data-testid="panel-desktop-menu"
          class="lg:r-3 relative flex h-12 w-12 items-center justify-center rounded-full border
            border-gray-300 bg-white shadow-lg xl:hidden"
          @click="toggleMenu"
        >
          <span class="text-gray-700">✖</span>
        </button>
      </div>
      <div class="flex flex-col items-start xl:hidden">
        <div class="mt-3 flex items-center gap-2">
          <PanelAvatar class="pointer-events-none ml-1 block" />
          <div class="text-sm font-medium text-gray-900">
            {{ form.first_name }} {{ form.last_name }}
          </div>
        </div>
        <PrimeDivider class="!my-4 !mb-4 before:!border-[#D0D5DD]" />
      </div>
      <div class="hidden xl:block">
        <PrimeDivider class="!my-6 before:!border-[#FFFFFF29]" />
      </div>
      <PanelMainMenu
        :menu-items="menuItems"
        data-testid="panel-main-menu"
        @close-menu="toggleMenu"
      />
      <div class="xl:hidden">
        <PrimeDivider class="!mt-1 before:!border-[#D0D5DD]" />
        <NuxtLink
          to="/settings"
          class="duration-400 w-100 mb-3 flex items-center rounded-lg p-3 px-1 text-sm
            font-medium text-gray-900 transition-all ease-linear hover:bg-[#0000001F]
            xl:px-3 xl:text-surface-0"
          @click="toggleMenu"
        >
          <i class="pi pi-cog mr-2 text-lg"></i>
          <span>Ustawienia</span>
        </NuxtLink>
        <div
          class="duration-400 w-100 mb-3 flex items-center rounded-lg p-3 px-1 text-sm
            font-medium text-gray-900 transition-all ease-linear hover:bg-[#0000001F]
            xl:px-3 xl:text-surface-0"
          @click="logUserOut()"
        >
          <i class="pi pi-sign-out mr-2 text-lg"></i>
          <span class="text-sm font-medium text-black">Wyloguj się</span>
        </div>
      </div>
    </div>
  </aside>
</template>
